import { useState, useEffect } from 'react';
import Api from '../api/api';
import { toInputFieldDateTimeString, toInputFieldDateString, isToDateAfterFromDate, dateRange, toDateString, toTimeString } from '../../utilities/dateUtilities';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import { ClientSiteTabbed } from '../allow-list/clientSiteTabbed';
import formUtilities from '../../utilities/formUtilities';
import { ErrorModal } from '../../utilities/errorModal';
import { SiteAllowList } from './siteAllowList';
import Modal from 'react-bootstrap/Modal';
import { TimeRangeSlider } from '../shared/timeRangeSlider';
import { DateTimePickerWithCustomDisplay } from '../shared/dateTimePickerCustomDisplay';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { ClientLandingFiltersModal } from './filters-modals/clientLandingFiltersModal';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { MinutesInputWithUnit } from '../shared/minutesInputWithUnit';

function ClientLanding(props) {

    const userOrganisation = props.user.organisations.find(x => x.organisation.id === props.organisationId);
    const assignedSiteIds = userOrganisation?.siteIds
    const assignedSiteGroupIds = userOrganisation?.siteGroupIds
    const [sites, setSites] = useState(null);
    const [vrm, setVrm] = useState("");
    const [site, setSite] = useState(null);
    const [vehicleMake, setVehicleMake] = useState("");
    const [vehicleModel, setVehicleModel] = useState("");
    const [colour, setColour] = useState("");
    const [reference, setReference] = useState("");    
    const [driverName, setDriverName] = useState("");
    const [driverMobileNumber, setDriverMobileNumber] = useState("");
    const [blueBadgeNumber, setBlueBadgeNumber] = useState("");
    const [blueBadgeExpiryDate, setBlueBadgeExpiryDate] = useState("");
    const [driverEmailAddress, setDriverEmailAddress] = useState("");
    const [startDate, setStartDate] = useState(props.areDatesRequired ? new Date().toISOString() : "");
    const [endDate, setEndDate] = useState("");
    const [indefinite, setIndefinite] = useState(false);
    const [reason, setReason] = useState("");
    const [canSave, setCanSave] = useState(false);
    const [siteGroups, setSiteGroups] = useState(null);
    const [siteGroup, setSiteGroup] = useState("");
    const [roi, setRoi] = useState(null);    
    const [clients, setClients] = useState(null);
    const [allowListClientId, setAllowListClientId] = useState("");
    const [tabActiveKey, setTabActiveKey] = useState(arrayUtilities.isNullOrEmpty(assignedSiteIds) ? "client" : "site");
    const [allowListError, setAllowListError] = useState("");
    const [typeDateTime, setTypeDateTime] = useState(props.areDatesRequired ? "2" : "0")
    const { firstDate, lastDate, displayString } = dateRange("currentDay")
    const [vehicleLookupError, setVehicleLookupError] = useState(null)
    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    const [validOnlyOnSpecificDays, setValidOnlyOnSpecificDays] = useState(false)
    const [isValidMonday, setIsValidMonday] = useState(false)
    const [isValidTuesday, setIsValidTuesday] = useState(false)
    const [isValidWednesday, setIsValidWednesday] = useState(false)
    const [isValidThursday, setIsValidThursday] = useState(false)
    const [isValidFriday, setIsValidFriday] = useState(false)
    const [isValidSaturday, setIsValidSaturday] = useState(false)
    const [isValidSunday, setIsValidSunday] = useState(false)
    const [enabledFromTime, setEnabledFromTime] = useState("00:00:00")
    const [enabledToTime, setEnabledToTime] = useState("23:00:00")
    const [validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes] = useState(false)
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);

    //filtering allow list table
    const [search, setSearch] = useState(null);
    const [searchResetSignal, setSearchResetSignal] = useState(0);
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);
    const [filterPeriodType, setFilterPeriodType] = useState(0);
    const [selectedTags, setSelectedTags] = useState([]);
    const [multiDeleteList, setMultiDeleteList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const getClients = () => {
        setLoading(true)
        Api.getClients(
            data => {
                setClients(data);
                if (data.length === 1) {
                    setAllowListClientId(data[0].id)
                }
                
                if (!arrayUtilities.isNullOrEmpty(data)) {
                    Api.getSites(
                        sitesData => setSites(sitesData),
                        error => console.log(error),
                        props.organisationId, props.token
                    )
                }
                else {
                    setSites([])
                }
                setLoading(false)
            },
            error => {
                console.log(error)
                setLoading(false)
            },
            props.organisationId,
            props.token
        )
    }

    const clearFiltersAfterAllowListSubmission = function () {
        setSearch("");
        setSearchResetSignal(prevSignal => prevSignal + 1)
        setFilterStart(null);
        setFilterEnd(null);
        setLoading(true);
        setFilterPeriodType(0)
        setSelectedTags([])
        setAppliedFilters(null)
        setShowFilterPills(false)
    };

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Period Type":
                setFilterPeriodType(0)
                break
            case "From":
                setFilterStart(null)
                break
            case "To":
                setFilterEnd(null)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                break
            case "Tags":
                setSelectedTags([])
                break
            default:
                break
        }
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                break
            default:
                break
        }
    }

    const isSiteMatchingSelectedTags = (site, client) => {
        if (arrayUtilities.isNullOrEmpty(selectedTags)) return true
        const siteTagIds = (site.tags ?? []).map(tag => tag.id)
        const clientTagIds = (client.tags ?? []).map(tag => tag.id)
        return [...siteTagIds, ...clientTagIds].some(tagId => selectedTags.includes(tagId))
    }

    const clearVrmData = function () {
        setVrm("");
        setVehicleMake("");
        setVehicleModel("");
        setColour("");
        setReference("")
        setSite(null);
        setDriverName("");
        setDriverMobileNumber("");
        setBlueBadgeNumber("");
        setBlueBadgeExpiryDate("");
        setIndefinite(false);
        setStartDate(props.areDatesRequired ? new Date().toISOString() : "");
        setEndDate("");
        setReason("");
        setSiteGroup("");
    };

    const submit = function () {
        if (canSave) {
            var submitSiteId;
            var siteName;
            if (site !== null) {
                submitSiteId = site.id;
                siteName = site.name;
            } else {
                submitSiteId = null;
                siteName = "All Sites";
            }
            Api.addAllowedVrm(
                data => {
                    if (data.isError) {
                        setAllowListError(data.errorMessage)
                    } else {
                        clearFiltersAfterAllowListSubmission();
                        clearVrmData();
                        getClients()
                        setAllowListError(null)
                    }
                },
                (error) => {
                    console.log(error)
                    setAllowListError(error.errorMessage)
                },
                vrm,
                vehicleMake,
                vehicleModel,
                colour,
                reference,
                driverName,
                driverMobileNumber,
                stringHelpers.isNullOrEmpty(startDate) ? null: new Date(startDate).toISOString(),
                stringHelpers.isNullOrEmpty(endDate) ? null : new Date(endDate).toISOString(),
                validOnlyAtSpecificTimes ? enabledFromTime + ':00' : null,
                validOnlyAtSpecificTimes ? enabledToTime + ':00' : null,
                isValidMonday,
                isValidTuesday,
                isValidWednesday,
                isValidThursday,
                isValidFriday,
                isValidSaturday,
                isValidSunday,
                reason,
                (tabActiveKey === "client" || stringHelpers.isNullOrEmpty(submitSiteId)) ? null : submitSiteId,
                (tabActiveKey === "site" || stringHelpers.isNullOrEmpty(allowListClientId)) ? null : allowListClientId,
                null,
                roi,
                !stringHelpers.isNullOrEmpty(siteGroup) ? siteGroup : null,
                !stringHelpers.isNullOrEmpty(blueBadgeNumber) ? blueBadgeNumber : null,
                !stringHelpers.isNullOrEmpty(blueBadgeExpiryDate) ? blueBadgeExpiryDate : null,
                maxStayMinutes,
                noReturnWithinMinutes,
                props.organisationId,
                props.token
            );
        }
    };

    useEffect(() => {
        setCanSave(
            ((site && site !== null) || !stringHelpers.isNullOrEmpty(allowListClientId) || (props.areDatesRequired && !stringHelpers.isNullOrEmpty(startDate))) &&
            (!stringHelpers.isNullOrEmpty(vrm) && stringHelpers.isValidVrm(vrm)) &&
            isToDateAfterFromDate(startDate, endDate)
        );

    }, [site, vrm, indefinite, startDate, endDate, allowListClientId]);

    useEffect(() => getClients(), []);

    useEffect(() => {
        if (site) {
            Api.getSiteGroupsBySiteId(
                props.organisationId, site.id, 
                result => {
                    setSiteGroups(result);
                    if (arrayUtilities.isNullOrEmpty(result)) {
                        setSiteGroup(null)
                    }
                },
                error => console.log(error),
                props.token
            )
        }
    }, [site])

    const handleCheckChange = (value) => {
        multiDeleteList.includes(value)
            ? setMultiDeleteList(prevState => prevState.filter(item => item !== value))
            : setMultiDeleteList(prevState => [...prevState, value]);
    }

    const handleMultiDeleteConfirm = () => {
        setLoading(true)
        Api.deleteMultipleAllowListVrms(
            data => {
                if (data.isError) {
                    setLoading(false)
                    setAllowListError(data.errorMessage)
                } else {
                    setMultiDeleteList([]);
                    getClients();
                }
            },
            error => {
                setLoading(false)
                setAllowListError(error.errorMessage)
            },
            props.organisationId,
            multiDeleteList,
            props.token
        )
        setShowDeleteModal(false);
    }

    const vehicleLookup = () => {
        setLoadingVehicleLookup(true)
        Api.vehicleLookup(
            data => {
                if (data.isError) {
                    setVehicleLookupError(data.errorMessage)
                } else {
                    setVehicleMake(data.vehicleMake)
                    setVehicleModel(data.vehicleModel)
                    setColour(data.vehicleColour)
                    setSuccessfulLookupVrm(vrm)
                    setVehicleLookupError(null)
                }
                setLoadingVehicleLookup(false)
            },
            () => {
                setVehicleLookupError("Error locating details")
                setLoadingVehicleLookup(false)
            },
            vrm,
            props.organisationId, props.token
        )
    }

    const hasNoTagMatchingSites = !arrayUtilities.isNullOrEmpty(selectedTags)
        && !arrayUtilities.isNullOrEmpty(clients)
        && !arrayUtilities.isNullOrEmpty(sites)
        && !clients.some(client => sites.some(site => site.clientId === client.id && isSiteMatchingSelectedTags(site, client)))

    return (
        <>
            {sites !== null && <>
                <div className="container-fluid">
                    {
                        !stringHelpers.isNullOrEmpty(allowListError) &&
                        <ErrorModal
                            message={ allowListError }
                            onHide={ () => setAllowListError(null) }
                        />
                    }
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-auto d-flex align-items-center">
                                            <h5 className="mb-0">Allow List</h5>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <SearchBarWithDebounce resetSignal={ searchResetSignal } onSearchQueryChange={ query => { setLoading(true); setSearch(query) } } />
                                            <div className='ml-2'>
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                            <button className="btn btn-primary btn-sm ml-2 nowrap" data-toggle="modal" data-target="#allow-list-modal"><i className="fas fa-plus mr-1"></i> Add to Allow List</button>
                                            <button
                                                disabled={ arrayUtilities.isNullOrEmpty(multiDeleteList)}
                                                onClick={() => setShowDeleteModal(true)}
                                                className="btn btn-danger btn-sm col-auto ml-1">
                                                <i className="fas fa-trash"></i> Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => <AppliedFilterPill
                                                    key={ label }
                                                    label={ label }
                                                    value={ value }
                                                    renderItemLabel={ renderTagFilterItemLabel }
                                                    onTextClick={ () => setShowFiltersModal(true) }
                                                    onCloseClick={ handleFilterPillClose }
                                                    onRemoveItem={ handleFilterPillItemRemove }
                                                />
                                            )
                                        }
                                        { appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => {
                                            setFilterStart(null)
                                            setFilterEnd(null)
                                            setFilterPeriodType(0)
                                            setSelectedTags([])
                                            setAppliedFilters(null)
                                        } }>Clear all filters</button> }
                                    </div>
                                }
                                <div className="card-body bg-light border-top details-container">
                                    <div className="modal fade allow-list-modal" id="allow-list-modal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="deleteModalLabel">Add to Allow List</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">VRM<span className="req"></span></p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className='d-flex align-items-start'>
                                                                <div className="form-group mb-1">
                                                                    <input disabled={loadingVehicleLookup} required className="form-control mb-1 small-number-plate" type="text" value={ vrm } onChange={ (e) => {
                                                                        if (!stringHelpers.isNullOrEmpty(vehicleLookupError)) {
                                                                            setVehicleLookupError(null)
                                                                        }
                                                                        setVrm(e.target.value.toUpperCase());
                                                                        formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                                    } } />
                                                                    <small className='invalid-feedback text-danger'>Please enter a VRM</small>

                                                                    {
                                                                        !stringHelpers.isNullOrEmpty(vrm) &&
                                                                        <small className='text-danger'>
                                                                            {
                                                                                !stringHelpers.isValidVrm(vrm)
                                                                                    ? <>Invalid VRM format</>
                                                                                    : !stringHelpers.isNullOrEmpty(vehicleLookupError) && vehicleLookupError
                                                                            }
                                                                        </small>
                                                                    }
                                                                </div>
                                                                <button
                                                                    onClick={ () => vehicleLookup() }
                                                                    disabled={ 
                                                                        stringHelpers.isNullOrEmpty(vrm) || 
                                                                        !stringHelpers.isValidVrm(vrm) || 
                                                                        (
                                                                            !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                                        ) ||
                                                                        loadingVehicleLookup 
                                                                    }
                                                                    className='btn btn-falcon-default btn-sm ml-3 mt-2'
                                                                >
                                                                    <div className='d-flex align-items-center'>
                                                                        {
                                                                            loadingVehicleLookup
                                                                                ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                                : <i className='fas fa-search mr-1'></i>
                                                                        }
                                                                        Vehicle Lookup
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Reference</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={reference} onChange={(e) => setReference(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Vehicle Make</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleMake} onChange={(e) => setVehicleMake(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Vehicle Model</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleModel} onChange={(e) => setVehicleModel(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Colour</p>
                                                        </div>
                                                        <div className="col-md-8 col-12 ">
                                                            <div className="form-group mb-1">
                                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={colour} onChange={(e) => setColour(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <h6 className="mb-3 fs-1">Driver Details</h6>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Name</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="text" value={driverName} onChange={(e) => setDriverName(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Mobile Number</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-0">
                                                                <input className="form-control mb-1" type="text" value={driverMobileNumber} onChange={(e) => setDriverMobileNumber(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Email Address</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={driverEmailAddress} onChange={(e) => setDriverEmailAddress(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Blue Badge Number</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="text" value={blueBadgeNumber} onChange={(e) => setBlueBadgeNumber(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold  mt-1 mb-1 text-left">Blue Badge Expiry Date</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <input className="form-control mb-0" type="date" value={toInputFieldDateString(blueBadgeExpiryDate)} onChange={(e) => setBlueBadgeExpiryDate(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <ClientSiteTabbed 
                                                        clients={clients}
                                                        client={allowListClientId}
                                                        onTabChange={e => {
                                                            setSiteGroup("");
                                                            setSite(null);
                                                            setRoi(null);
                                                            setTabActiveKey(e)
                                                        }}
                                                        anprCameraId={null}
                                                        site={site}
                                                        sites={sites}
                                                        setSite={setSite}
                                                        activeKey={tabActiveKey}
                                                        siteGroups={siteGroups}
                                                        siteGroup={siteGroup}
                                                        setSiteGroup={setSiteGroup}
                                                        anprCameras={null}
                                                        roi={roi}
                                                        setRoi={setRoi}
                                                        labelWidthClass='col-md-4 col-12'
                                                        fieldWidthClass='col-md-8 col-12'
                                                        setClient={setAllowListClientId}
                                                        isClientOrClientManager
                                                        assignedSiteIds={assignedSiteIds}
                                                        assignedSiteGroupIds={assignedSiteGroupIds}
                                                    />
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <div className="mandatory-date-time">
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <h6 className="mb-3 fs-1">Date/Time Details</h6>
                                                            </div>
                                                            {!props.areDatesRequired &&
                                                                <div className="col-md-8 col-12">
                                                                <div className="d-flex align-items-center mb-1">
                                                                    <input checked={typeDateTime==="0"} id={"0"}
                                                                           onChange={()=>{
                                                                               setTypeDateTime("0")
                                                                               setStartDate("")
                                                                               setEndDate("")
                                                                           }} className='mr-2'
                                                                           name="type-date-time-selection-radio"
                                                                           key={"0"} value={"0"} type='radio'/>
                                                                    <label className='m-0' htmlFor={"0"}>Indefinite (no start/end date)</label>
                                                                </div>

                                                                <div className="d-flex mb-1 align-items-start">
                                                                    <input checked={typeDateTime==="1"} id={"1"}
                                                                           onChange={()=>{
                                                                               setTypeDateTime("1")
                                                                               setStartDate(toInputFieldDateTimeString(firstDate))
                                                                               setEndDate(toInputFieldDateTimeString(lastDate))
                                                                           }} className='mr-2 mt-1'
                                                                           name="type-date-time-selection-radio"
                                                                           key={"1"} value={"1"} type='radio'/>
                                                                    <div className="">
                                                                        <label className='m-0 d-flex flex-column'
                                                                               htmlFor={"1"}>
                                                                            Today
                                                                            <small>{toDateString(firstDate)}, {toTimeString(firstDate)} - {toTimeString(lastDate)}</small>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-center mb-1">
                                                                    <input checked={typeDateTime==="2"} id={"2"}
                                                                           onChange={()=>{
                                                                               setTypeDateTime("2")
                                                                               setStartDate("")
                                                                               setEndDate("")
                                                                           }} className='mr-2'
                                                                           name="type-date-time-selection-radio"
                                                                           key={"2"} value={"2"} type='radio'/>
                                                                    <label className='m-0' htmlFor={"2"}>Specific date
                                                                        range</label>
                                                                </div>
                                                            </div>}
                                                        </div>

                                                        {
                                                            typeDateTime === "2"
                                                            &&
                                                            <>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4 col-12 ">
                                                                        <p className="text-left font-weight-semi-bold  mt-1 mb-1">Date Range</p>
                                                                    </div>
                                                                    <div className="col-md-8 col-12">
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className="form-group mb-0">
                                                                            <DateTimePickerWithCustomDisplay
                                                                                customDisplayText="No start date"
                                                                                onChange={ v => setStartDate(v) }
                                                                                value={ toInputFieldDateTimeString(startDate) }
                                                                            />
                                                                        </div>
                                                                        <p className='m-0 mx-2'>To</p>
                                                                        <div className="form-group mb-0">
                                                                            <DateTimePickerWithCustomDisplay
                                                                                customDisplayText="No end date"
                                                                                onChange={ v => setEndDate(v) }
                                                                                value={ toInputFieldDateTimeString(endDate) }
                                                                            />
                                                                        </div>
                                                                        </div>
                                                                        {
                                                                            props.areDatesRequired &&
                                                                            (stringHelpers.isNullOrEmpty(startDate) || startDate === "yyyy-MM-dd")
                                                                            && <small className='text-danger mt-1'>A start date is required</small>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-3">
                                                                    <div className="col-md-4 col-12 ">
                                                                        <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only on specific days</p>
                                                                    </div>
                                                                    <div className="col-md-8 col-12 custom-control custom-switch">
                                                                        <input className="custom-control-input" type="checkbox" id="valid-specific-days-toggle" checked={ validOnlyOnSpecificDays } onChange={ e => {
                                                                            setValidOnlyOnSpecificDays(!validOnlyOnSpecificDays)
                                                                            if (!e.target.checked) {
                                                                                setValidOnlyOnSpecificDays(false)
                                                                                setIsValidMonday(false)
                                                                                setIsValidTuesday(false)
                                                                                setIsValidWednesday(false)
                                                                                setIsValidThursday(false)
                                                                                setIsValidFriday(false)
                                                                                setIsValidSaturday(false)
                                                                                setIsValidSunday(false)
                                                                            }
                                                                        } } />
                                                                        <label className="custom-control-label ml-3" htmlFor="valid-specific-days-toggle"></label>
                                                                        <p className="text-left m-0 ml-3 mt-1">{ validOnlyOnSpecificDays ? <>Yes</> : <>No</> }</p>
                                                                    </div>
                                                                </div>
                                                                <div className='mt-3'>
                                                                    {
                                                                        validOnlyOnSpecificDays &&
                                                                        <>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Monday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-monday-switch" checked={ isValidMonday } onChange={ e => setIsValidMonday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-monday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidMonday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Tuesday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-tuesday-switch" checked={ isValidTuesday } onChange={ e => setIsValidTuesday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-tuesday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidTuesday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Wednesday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-wednesday-switch" checked={ isValidWednesday } onChange={ e => setIsValidWednesday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-wednesday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidWednesday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Thursday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-thursday-switch" checked={ isValidThursday } onChange={ e => setIsValidThursday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-thursday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidThursday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Friday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-friday-switch" checked={ isValidFriday } onChange={ e => setIsValidFriday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-friday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidFriday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Saturday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-saturday-switch" checked={ isValidSaturday } onChange={ e => setIsValidSaturday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-saturday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidSaturday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-4 col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Sunday</p>
                                                                                </div>
                                                                                <div className="col-md-8 col-12 custom-control custom-switch">
                                                                                    <input className="custom-control-input" type="checkbox" id="enable-sunday-switch" checked={ isValidSunday } onChange={ e => setIsValidSunday(prevState => !prevState) } />
                                                                                    <label className="custom-control-label ml-3" htmlFor="enable-sunday-switch"></label>
                                                                                    <p className="m-0 ml-3 mt-1">{ isValidSunday ? <>Yes</> : <>No</> }</p>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                <div className="row mt-3">
                                                                    <div className="col-md-4 col-12 ">
                                                                        <p className="text-left font-weight-semi-bold  mt-1 mb-1">Valid only at specific times of the day</p>
                                                                    </div>
                                                                    <div className="col-md-8 col-12 custom-control custom-switch">
                                                                        <input className="custom-control-input" type="checkbox" id="valid-specific-times-toggle" checked={ validOnlyAtSpecificTimes } onChange={ e => {
                                                                            setValidOnlyAtSpecificTimes(!validOnlyAtSpecificTimes)
                                                                            if (!e.target.checked) {
                                                                                setValidOnlyAtSpecificTimes(false)
                                                                                setEnabledFromTime("00:00:00")
                                                                                setEnabledToTime("23:59:59")
                                                                            }
                                                                        } } />
                                                                        <label className="custom-control-label ml-3" htmlFor="valid-specific-times-toggle"></label>
                                                                        <p className="text-left m-0 ml-3 mt-1">{ validOnlyAtSpecificTimes ? <>Yes</> : <>No</> }</p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    
                                                    {
                                                        validOnlyAtSpecificTimes &&
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 col-12 ">
                                                                <p className="font-weight-semi-bold mt-1 mb-1 text-left">Time Range</p>
                                                            </div>
                                                            <div className="col-md-7 col-12">
                                                                <TimeRangeSlider
                                                                    startTime={ enabledFromTime }
                                                                    endTime={ enabledToTime }
                                                                    onChange={ value => {
                                                                        setEnabledFromTime(value.startTime)
                                                                        setEnabledToTime(value.endTime)
                                                                    } }
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                        
                                                            <div className="row mt-3 mb-1">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <MinutesInputWithUnit
                                                                        numberOfMinutes={ maxStayMinutes }
                                                                        handleChange={ setMaxStayMinutes }
                                                                    />
                                                                    <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                                                                        <i className="fas fa-undo mr-1"></i>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        

                                                        
                                                            <div className="row mb-3">
                                                                <div className="col-md-4 col-12 ">
                                                                    <p className="font-weight-semi-bold mb-1">No return within</p>
                                                                </div>
                                                                <div className="col-md-8 col-12 d-flex align-items-center">
                                                                    <MinutesInputWithUnit
                                                                        numberOfMinutes={ noReturnWithinMinutes }
                                                                        handleChange={ setNoReturnWithinMinutes }
                                                                    />
                                                                    <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                                                                        <i className="fas fa-undo mr-1"></i>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        
                                                    </div>
                                                    <hr className="border-dashed border-bottom-0"></hr>
                                                    <div className="row">
                                                        <div className="col-md-4 col-12 ">
                                                            <p className="font-weight-semi-bold mt-1 mb-1 text-left">Notes</p>
                                                        </div>
                                                        <div className="col-md-8 col-12">
                                                            <div className="form-group mb-1">
                                                                <textarea className="form-control mb-0" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} data-dismiss="modal" onClick={() => submit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tickets-table">
                                        <div className="table-body">
                                            {
                                                !arrayUtilities.isNullOrEmpty(clients) && !arrayUtilities.isNullOrEmpty(sites) && 
                                                clients.map(
                                                    client => {
                                                        const sitesByClient = sites.filter(item => item.clientId === client.id && isSiteMatchingSelectedTags(item, client))
                                                        return !arrayUtilities.isNullOrEmpty(sitesByClient) && <>
                                                            <h5 className='mb-0'>{ client.name }</h5>
                                                            <div className='pl-2'>
                                                                {
                                                                    sitesByClient.map(
                                                                        site => <SiteAllowList multiDeleteList={ multiDeleteList } site={ site } key={ site.id } { ...props } handleCheckChange={ value => handleCheckChange(value) } siteId={ site.id } siteName={ site.name } search={ search } start={ filterStart } end={ filterEnd } filterPeriodType={ filterPeriodType } loading={ loading } setLoading={ setLoading } sites={ sites } setErrorMessage={ setAllowListError } />
                                                                    )
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                )
                                            }
                                            {
                                                hasNoTagMatchingSites &&
                                                <p className="text-center text-600 my-4">No sites match these filters</p>
                                            }
                                            {
                                                !loading && arrayUtilities.isNullOrEmpty(clients) &&
                                                <p className="text-center text-600 my-4">You have not been assigned to any sites. Please contact your administrator.</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={ showDeleteModal } onHide={ () => setShowDeleteModal(false) }>
                    <Modal.Header>
                        <Modal.Title>
                            Delete { multiDeleteList.length } VRM{ multiDeleteList.length > 1 ? "s" : "" }. Are you sure?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <button
                            className="btn btn-sm btn-danger mt-1"
                            onClick={ () => setShowDeleteModal(false) }
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-success mt-1"
                            onClick={ handleMultiDeleteConfirm }
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Modal>
                {
                    showFiltersModal &&
                    <ClientLandingFiltersModal
                        showModal={ showFiltersModal }
                        handleClose={ () => setShowFiltersModal(false) }
                        handleConfirm={ (draftFilters) => {
                            setFilterStart(draftFilters.filterStart)
                            setFilterEnd(draftFilters.filterEnd)
                            setFilterPeriodType(draftFilters.filterPeriodType)
                            setSelectedTags(draftFilters.selectedTags)
                            setAppliedFilters(draftFilters.appliedFilters)
                            setShowFilterPills(true)
                            setShowFiltersModal(false)
                        } }
                        initialFilterStart={ filterStart }
                        initialFilterEnd={ filterEnd }
                        initialFilterPeriodType={ filterPeriodType }
                        initialSelectedTags={ selectedTags }
                        initialAppliedFilters={ appliedFilters }
                        tags={ props.tags || [] }
                        key="client-landing-filters-modal"
                    />
                }
            </>}
        </>
    )
}
export default ClientLanding;